<template>
    <div>
        <div class="grid grid-cols-12 gap-6">
            <div class="hidden md:col-span-1 md:block" />
            <div class="col-span-12 text-left md:col-span-10">
                <h2>Ostatní prameny</h2>
                <div class="mt-5 mb-5">
                    <img
                        src="../../public/img/articles/ostatni_prameny.webp"
                        alt=""
                        class="mb-1 aspect-auto w-full object-cover"
                    />
                    <span class="source"
                        >Titulní list zápisu ze schůze Ústředního národního
                        výboru hl. m. Prahy, kde se rozhodovalo o názvech ulic.
                        / Zdroj: Archiv hl. m. Prahy</span
                    >
                </div>
                <p class="mb-5 font-bold">
                    Přehled klíčových pramenů k výzkumu názvů pražských ulic –
                    od usnesení zastupitelstev přes kroniky až po fotografie.
                    Zvláštní pozornost je věnována přejmenování ulic po
                    připojení obcí k Praze v letech 1968 a 1974.
                </p>

                <p class="font-bold">Usnesení zastupitelských sborů</p>
                <p class="mb-5">
                    Od zavedení úředních názvů ulic jsou jedním ze základních
                    pramenů, které rozhodovaly o ustanovení a změnách názvů,
                    usnesení pražských zastupitelských sborů. Šlo zejména o
                    úřední sdělení publikovaná ve Věstníku obecním královského
                    hl. m. Prahy (vycházel od roku 1894, později od roku 1918
                    jako Věstník hl. m. Prahy) o zavedení nových názvů ulic a
                    náměstí. Originální usnesení městské rady mnohdy neobsahují
                    schválené názvy, ale pouze odkazy na čísla jednací
                    předkládaných dokumentů. Některé z těchto písemností
                    předkládaných radě či komisím jsou dochovány, avšak nikoli
                    kompletně, a zejména pro období po vzniku tzv. Velké Prahy
                    nemáme k dispozici žádný seznam ulic. Od roku 1945, resp.
                    1958, kdy vznikla již zmíněná publikace Ulicemi města Prahy,
                    jsou dochovány zápisy ze schůzí rady v kontinuální řadě od
                    roku 1945, a máme tedy k dispozici víceméně kompletní řadu
                    usnesení o pojmenování a přejmenování uličních názvů. To se
                    však netýká schválení názvů připojených obcí. Nejnovější
                    usnesení rady pak můžeme najít on-line na stránkách

                    <a
                        href="https://praha.eu/archiv-usneseni-rady-hmp"
                        target="_blank"
                        class="article-link"
                        >praha.eu/archiv-usneseni-rady-hmp.
                    </a>

                    V jednotlivých ulicích odkazujeme na tyto stránky, avšak
                    uvádíme i citace (číslo a datum usnesení) pro případ, že by
                    odkazy přestaly fungovat.
                </p>
                <p class="mb-5">
                    Samostatnou kapitolou jsou pak změny názvů ulic, které si
                    vynutilo připojení okolních obcí k hlavnímu městu v roce
                    1968 a 1974. Přestože pojmenování a přejmenování ulic v
                    Praze měla už tehdy jasně v kompetenci městská rada, byla
                    tato agenda v připojených obcích v roce 1968 a v roce 1974
                    svěřena do pravomoci místních národních výborů připojených
                    obcí, přičemž koordinaci prováděl odbor vnitřních věcí
                    Národního výboru hlavního města Prahy.
                </p>

                <p class="mb-5">
                    Je zřejmé, že si obě rozsáhlé akce – odstranění duplicitních
                    názvů a pojmenování dosud nepojmenovaných ulic v nově
                    připojených obcích jak v roce 1968, tak v roce 1974 –
                    vyžádaly mnoho času, resp. několik let. Bohužel ve výsledku
                    celá tato akce, která se týkala více než 2000 ulic, neprošla
                    radou hlavního města Prahy, takže jediným úředním pramenem
                    jsou pro nás dva komparativní seznamy (z roku 1968 a 1974)
                    zachycující bez bližšího vysvětlení původní název veřejného
                    prostranství v té které připojené obci před připojením a
                    nový název po připojení k Praze. Ani další prameny (mapy,
                    kroniky obcí) vesměs nepřinesly kýžené upřesnění a osvětlení
                    těchto názvů.
                </p>

                <p class="font-bold">Kroniky</p>
                <p class="mb-5">
                    Důležitým pramenem pro bádání o názvech v připojených
                    částech Prahy jsou kroniky jednotlivých obcí a také údaje od
                    pamětníků, kronikářů a pracovníků úřadů městských částí.
                    Kroniky přinášejí v menší míře údaje o pojmenování a názvech
                    ulic, častěji je však možné je využít pro zjištění údajů o
                    zdejších osobách, pomístních názvech a dalších objektech,
                    podle kterých se ulice jmenují. Kroniky městských částí jsou
                    v posledním desetiletí intenzivněji předávány k uložení do
                    Archivu hl. m. Prahy a digitalizovány, jak pro potřeby
                    městských částí, tak pro potřeby Archivu hl. m. Prahy a
                    badatelské veřejnosti. Jsou dostupné na internetových
                    stránkách Archivu hl m. Prahy v jeho archivním katalogu –
                    <a
                        href="http://katalog.ahmp.cz/pragapublica"
                        target="_blank"
                        class="article-link"
                        >katalog.ahmp.cz/pragapublica.
                    </a>
                    Mnohé z kronik jsou také dostupné na internetových stránkách
                    jednotlivých městských částí.
                </p>

                <p class="font-bold">Fotografie</p>
                <p class="mb-10 sm:mb-25">
                    Fotografie a terénní výzkum mohou přinést informace o tom,
                    že některé ulice, jejichž název byl úředně schválen a jsou
                    vyznačené v plánech, mohou být na místě označeny názvy
                    odlišnými. Jde vesměs o jednotlivosti, ale takové případy
                    potvrzují, že všechny informace o názvech ulic, ať už
                    úřední, či neúřední povahy, mohou být nepřesné a někdy i
                    mylné. Při tisících názvech ulic a jiných prostranství je to
                    pochopitelné.
                </p>

                <!-- next chapters -->
                <div class="mb-10 flex justify-between border-t-1 pt-5">
                    <p class="mb-5 w-1/2 border-r-1 font-bold">
                        <nuxt-link
                            to="/clanky/prameny-plany-prahy"
                            class="flex justify-start underline"
                        >
                            <img
                                src="../../public/img/left-arrow.png"
                                alt=""
                                class="order-1 mr-2 inline h-5 w-5"
                            />
                            <span class="order-2 mr-2"
                                >Prameny – plány Prahy</span
                            >
                        </nuxt-link>
                    </p>
                    <p class="mb-5 w-1/2 text-right font-bold">
                        <nuxt-link
                            to="/clanky/literatura"
                            class="flex justify-end underline"
                        >
                            <span class="order-1 ml-2">Literatura</span>
                            <img
                                src="../../public/img/right-arrow.png"
                                alt=""
                                class="order-2 ml-2 inline h-5 w-5"
                            />
                        </nuxt-link>
                    </p>
                </div>
            </div>
            <div class="hidden md:col-span-1 md:block" />
        </div>

        <AppFooter />
    </div>
</template>

<script setup lang="ts"></script>

<style scoped></style>
